import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center gap-1 w-full" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickProfile && _ctx.btnClickProfile(...args))),
      type: "button",
      class: _normalizeClass([{'text-stroke! text-stroke-white!': _ctx.session.get('navbar_primary') === 'profile' }, "flex justify-center items-center w-full text-center bg-[url()] bg-size-[100%_100%] cursor-pointer"])
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("img", {
        class: "w-full",
        alt: "",
        src: "https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-my-profile-new.webp"
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickWallet && _ctx.btnClickWallet(...args))),
      type: "button",
      class: _normalizeClass([{'text-stroke! text-stroke-white!': _ctx.session.get('navbar_primary') === 'wallet' }, "flex justify-center items-center w-full text-center bg-[url()] bg-size-[100%_100%] cursor-pointer"])
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("img", {
        class: "w-full",
        alt: "",
        src: "https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-my-wallet-new.webp"
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickAffiliateLink && _ctx.btnClickAffiliateLink(...args))),
      type: "button",
      class: _normalizeClass([{'text-stroke! text-stroke-white!': _ctx.session.get('navbar_primary') === 'affiliate' }, "flex justify-center items-center w-full text-center bg-[url()] bg-size-[100%_100%] cursor-pointer"])
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("img", {
        class: "w-full",
        alt: "",
        src: "https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-my-affiliate.webp"
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickPromotionList && _ctx.btnClickPromotionList(...args))),
      type: "button",
      class: _normalizeClass([{'text-stroke! text-stroke-white!': _ctx.session.get('navbar_primary') === 'promotion' }, "flex justify-center items-center w-full text-center bg-[url()] bg-size-[100%_100%] cursor-pointer"])
    }, _cache[7] || (_cache[7] = [
      _createElementVNode("img", {
        class: "w-full",
        alt: "",
        src: "https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-my-promotion.webp"
      }, null, -1 /* HOISTED */)
    ]), 2 /* CLASS */)
  ]))
}